import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: false, // Changed from true to false as we're not using cookies anymore
});

// Initialize authorization header with token from localStorage if available
const token = localStorage.getItem('authToken');
if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Note: We can't use useAuth directly in a non-component module.
// Instead, we'll modify the interceptor to check the role from the response or URL.
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (
            error.response &&
            error.response.status === 401 &&
            !error.config.skipAuthRedirect &&
            !error.config.url.includes('/auth/me') &&
            !error.config.url.includes('/auth/user/login') &&
            !error.config.url.includes('/auth/admin/login')
        ) {
            // console.log("Unauthorized detected, determining redirect");
            // Check if the request was for an admin route
            const isAdminRoute = error.config.url.includes('/admin/');
            const redirectPath = isAdminRoute ? '/admin/login' : '/login';
            // console.log(`Redirecting to ${redirectPath}`);

            // Clear localStorage auth data on 401 errors
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
            delete api.defaults.headers.common['Authorization'];

            window.location.href = redirectPath;
        } else {
            // console.log("Interceptor skipping redirect:", error.config.url);
        }
        return Promise.reject(error);
    }
);

export default api;